export const BASE_URL = "/assets/images/";
export const BASE_FILE_URL = "/assets/files/";